import { render, staticRenderFns } from "./BillsTabs.vue?vue&type=template&id=621487b4&"
import script from "./BillsTabs.vue?vue&type=script&lang=js&"
export * from "./BillsTabs.vue?vue&type=script&lang=js&"
import style0 from "./BillsTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports